<section class="bg-image">
  <div class="mask contant-height">
    <div
      class="d-flex align-items-center justify-content-center contant-height"
    >
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-center">
          <!-- <div routerLink="/home">
                    <i class="fa-solid fa-arrow-left" style="color: #ffffff;font-size: 1.5rem;cursor: pointer;"></i>
                </div> -->
          <div class="header-signup mb-4">
            <img
              src="/assets/logo/chessx-light-main-logo.svg"
              class="main-logo"
              alt=""
            />
          </div>
          <!-- <div>
                    <button routerLink="/signup" class="login-btn">Sign Up</button>
                </div> -->
        </div>
        <div class="form-main-box d-flex justify-content-center">
          <div class="form-box">
            <!-- <div routerLink="/signup">
                <i class="fa-sharp fa-solid fa-circle-arrow-left back-arrow " style="color: #000000;"></i>
              </div> -->
            <div class="justify-content-center d-flex mb-4 m-0">
              <h1>
                <img
                  src="assets/icon-image/card-look-sign-up-image.svg"
                  alt=""
                />
              </h1>
              <span class="Log-In-title ms-3">Log In</span>
            </div>

            <form (ngSubmit)="login(loginform.value)" [formGroup]="loginform">
              <div class="mb-3">
                <div class="inputWithIcon d-flex justify-content-center">
                  <input
                    type="text"
                    name="emailControl"
                    [formControl]="emailControl"
                    placeholder="Enter your Email Or username"
                    class="form-control text-white input-mb border-input"
                  />
                  <i class="fa fa-envelope fa-lg fa-fw" aria-hidden="true"></i>
                </div>

                <div
                  style="color: red"
                  *ngIf="
                    loginform.controls['query']?.invalid &&
                    (loginform.controls['query'].dirty ||
                      loginform.controls['query'].touched ||
                      submitted)
                  "
                  class=""
                >
                  <span
                    class="form-error mb-1"
                    *ngIf="loginform.controls['query'].errors?.['required']"
                    >Email is required.</span
                  >
                  <span
                    class="form-error"
                    *ngIf="loginform.controls['query'].errors?.['email']"
                    >Enter correct email address.</span
                  >
                </div>
              </div>

              <div class="mb-1">
                <label class="label text-white" for="oldPassword"
                  >Old password
                </label>
                <div class="right-inner-addon input-container">
                  <i
                    class="fa-solid fa-eye toggle-password"
                    (click)="showPassword = !showPassword"
                    [ngClass]="{
                      'fa-eye': !showPassword,
                      'fa-eye-slash': showPassword
                    }"
                  ></i>
                  <input
                    id="password"
                    placeholder="password"
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control text-white input-mb border-input"
                    formControlName="password"
                  />
                </div>

                <div
                  style="color: red"
                  *ngIf="
                    loginform.controls['password']?.invalid &&
                    (loginform.controls['password'].dirty ||
                      loginform.controls['password'].touched ||
                      submitted)
                  "
                  class=""
                >
                  <span
                    class="form-error"
                    *ngIf="loginform.controls['password'].errors?.['required']"
                    >Password is required.</span
                  >
                  <span
                    class="form-error"
                    *ngIf="loginform.controls['password'].errors?.['pattern']"
                    >Enter correct Password.</span
                  >
                </div>
              </div>

              <div class="d-flex justify-content-end remember-forget">
                <div class="form-check-label" (click)="forgetpass()">
                  Forgot Password?
                </div>
              </div>

              <div class="text-center">
                <button
                  [disabled]="loginform.invalid"
                  type="submit"
                  class="btn btn-primary btn-lg sinup-btn mt-2"
                >
                  Log In
                </button>
              </div>
            </form>

            <div class="main-or-div my-3">
              <span></span>
              <span class="main-or-text mb-2">or</span>
              <span></span>
            </div>

            <div class="text-center mb-3">
              <button
                type="button"
                class="btn btn-primary btn-lg sinup-btn btn-clr1"
                (click)="signInWithGoogle()"
              >
                <img
                  height="30"
                  src="../../../../../assets/icon-image/googleImage.svg"
                  width="45"
                  class="mt-1 google-img"
                />
                <span class="continue-text">Log in with Google</span>
              </button>
            </div>

            <div class="text-center">
              <p class="m-0 new-size">
                New?
                <a href="/signup" class="signup-link"
                  >Sign-up - and start playing chess!</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <form [formGroup]="resetEmail" (ngSubmit)="savePopup()" action="">
          <div
            class="justify-content-center align-items-center d-flex mb-4 m-0"
          >
            <h1>
              <img
                src="assets/icon-image/title-iconForgot-password.svg"
                alt=""
              />
            </h1>
            <span class="Forgot-password-title ms-3 modal-title"
              >Forgot password</span
            >
          </div>

          <div class="text-center">
            <img
              style="width: 50%"
              src="/assets/main-image/forgot-password-img.svg"
              alt=""
            />
          </div>

          <div>
            <div class="password-input mb-2">
              <div class="inputWithIcon mb-1">
                <input
                  style="width: 100%"
                  type="text"
                  name="emailControl"
                  id="resetemail"
                  formControlName="query"
                  placeholder="Enter your Email Or username"
                  class="input-mb"
                />
                <i class="fa fa-envelope fa-lg fa-fw" aria-hidden="true"></i>
              </div>
              <div
                *ngIf="
                  resetEmail.controls['query']?.invalid &&
                  (resetEmail.controls['query'].dirty ||
                    resetEmail.controls['query'].touched ||
                    submitted)
                "
                class="mb-1"
              >
                <span
                  class="form-error mb-1"
                  style="color: red"
                  *ngIf="resetEmail.controls['query'].errors?.['required']"
                  >Email is required.</span
                >
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer d-flex justify-content-between">
          <!-- <button type="button" (click)="closePopup()"
            class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded  password-input-reset">
            Cancel
          </button> -->
          <button
            type="button"
            (click)="savePopup()"
            [disabled]="resetEmail.invalid"
            class="btn profile-edit-button fw-bold btn-light shadow rounded password-input-save"
          >
            Submit
          </button>
          <button
            type="button"
            (click)="closePopup()"
            class="btn profile-edit-button fw-bold btn-light shadow rounded password-input-save"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle2 }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h4 class="modal-title text-center m-0">Enter Your OTP</h4>

        <div class="text-center">
          <img
            style="width: 50%"
            src="/assets/main-image/forgot-password-img.svg"
            alt=""
          />
        </div>

        <form [formGroup]="confirmOtp" (ngSubmit)="OtpPopups()" action="">
          <div>
            <div class="password-input mb-2">
              <div class="inputWithIcon mb-1">
                <input
                  style="width: 100%"
                  type="text"
                  name="otp"
                  id="otp"
                  formControlName="otp"
                  placeholder="Enter your OTP"
                  class="input-mb"
                />
                <i class="fa fa-envelope fa-lg fa-fw" aria-hidden="true"></i>
              </div>
            </div>
            <div class="text-end">
              <button
                class="btn"
                [disabled]="isButtonDisabled"
                (click)="onResend()"
              >
                Resend OTP @if(isButtonDisabled){
                <span> ({{ countdown }})</span>
                }
              </button>
            </div>
          </div>
        </form>
        <div class="modal-footer d-flex justify-content-between">
          <button
            type="button"
            (click)="otpClosePopUp()"
            class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded password-input-reset"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="OtpPopups()"
            [disabled]="confirmOtp.invalid"
            class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded password-input-save"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle3 }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h4 class="modal-title text-center">Enter Your NewPassword</h4>

        <div class="text-center">
          <img
            style="width: 50%"
            src="/assets/main-image/forgot-password-img.svg"
            alt=""
          />
        </div>

        <form
          class="form"
          [formGroup]="forgotpassword"
          (ngSubmit)="onSubmit(forgotpassword.value)"
        >
          <div class="mb-1">
            <div class="inputWithIcon d-flex justify-content-center">
              <input
                style="width: 100%"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="newPassword"
                class="form-control input-mb"
                id="newPassword"
                placeholder="new Password"
                #pw
              />
              <i
                class="fa-solid fa-eye icon-eyes"
                (click)="showPassword = !showPassword"
                [ngClass]="{
                  'fa-eye': !showPassword,
                  'fa-eye-slash': showPassword
                }"
              ></i>
            </div>
          </div>
          <!-- <div class=" form-floating mb-3">
            <i class="fa-solid fa-eye float-r" (click)="showPassword = !showPassword"
              [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
            <input style="width:100%;" id="newPassword" [type]="showPassword ? 'text' : 'password'" class="form-control input-background"
              formControlName="newPassword" #pw />


            <label class="label" for="newPassword">New password </label>
          </div> -->

          <div class="mb-1">
            <div class="inputWithIcon d-flex justify-content-center">
              <input
                id="confirmPassword"
                [type]="shownewpassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="form-control input-mb"
                placeholder="confirm New password"
                [ngClass]="confirmPasswordClass"
                #cpw
              />
              <i
                class="fa-solid fa-eye icon-eyes"
                (click)="shownewpassword = !shownewpassword"
                [ngClass]="{
                  'fa-eye': !shownewpassword,
                  'fa-eye-slash': shownewpassword
                }"
              ></i>
            </div>
            <div
              *ngIf="
                forgotpassword.hasError('confirmedValidator', [
                  'confirmPassword'
                ])
              "
            >
              Passwords do not match
            </div>
          </div>
          <!-- <div class="form-floating mb-3">
            <i class="fa-solid fa-eye float-r" (click)="shownewpassword = !shownewpassword"
              [ngClass]="{'fa-eye': !shownewpassword, 'fa-eye-slash': shownewpassword}"></i>
            <input id="confirmPassword" [type]="shownewpassword ? 'text' : 'password'"
              class="form-control input-background" [ngClass]="confirmPasswordClass" formControlName="confirmPassword"
              #cpw />

            <label class="label" for="confirmPassword">confirm New password</label>
          </div>
          <div *ngIf="forgotpassword.hasError('confirmedValidator', ['confirmPassword'])">
            Passwords do not match
          </div> -->
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn mx-auto col-5 mx-auto btn profile-edit-button password-input-reset fw-bold text-uppercase btn-light shadow rounded"
              routerLink="/login"
              (click)="resetclosepopup()"
            >
              cancel
            </button>
            <button
              type="submit"
              [disabled]="forgotpassword.invalid"
              class="col-5 mx-auto btn profile-edit-button password-input-save fw-bold text-uppercase btn-light shadow rounded"
            >
              Reset password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
